<template>
    <div>
        <CRow>
            <CCol lg="12">
                <CTableWrapper :items="getProducts" :itemsPerPage="itemsPerPage">
                    <template #header>
                        <CIcon name="cil-grid"/> Produkte aus XML <strong>({{ getProducts.length }})</strong>
                    </template>
                </CTableWrapper>
            </CCol>
        </CRow>
    </div>
</template>

<script>

    import CTableWrapper from './../base/Table.vue'
    import { mapActions, mapGetters } from 'vuex'

    export default {
        name: "List",
        components: {
            CTableWrapper
        },
        data:()=> ({
            fields: ['Shopware-ID', 'Marke', 'Produktname', 'Code', 'Steuern', 'Straßenpreis', 'Beschreibung', 'Gewicht'],
            itemsPerPage: 25

        }),
        methods: {
            ...mapActions('product', [
                'loadProducts'
            ])
        },

        created() {
            this.loadProducts()
        },

        computed: {
            ...mapGetters('product', [
                'getProducts'
            ])
        }
    }
</script>

<style scoped>

</style>
